import i18n from "i18next";

export const USER_LOCALE_KEY = "userLocale";

export const getUserLocale = (): string =>
  localStorage.getItem(USER_LOCALE_KEY) ||
  i18n.resolvedLanguage ||
  navigator.language;

// i18next also emits languageChanged when the first locale files finish loading.
export const subscribeToLanguageChange = (onChange: () => void) => {
  i18n.on("languageChanged", onChange);

  return () => i18n.off("languageChanged", onChange);
};
